var 
    $window,
    $body,
    Header
;

(function($){

    Header = {

        $ : null,
        $drops : null,
        $sebraeBar : null,
        $unityBar : null,
        $menuToggle : null,
        $toggles : null,
        $sliderWrapper : null,
        $slider : null,
        $floater : null,
        lastScrolTop : 0,
        timeFixa : null,
        locked : false,
        timeResize : false,

        init : function(){

            $body = $('body');
            $window = $(window);

            this.$ = $( '#masthead' );
            this.$sebraeBar = $body.children( '.sebrae-bar' ).first();
            this.$unityBar = $body.children( '.unity-bar' ).first();
            this.$menuToggle = $( '.menu-toggle' );
            this.$floater = $( '.menu-suspenso' );
            this.$overlay = $( '.menu-overlay', this.$ );

            // Vlibras
            $body.on( 'click', '[data-action="open-vlibras"]', function(){;
                var $vlibras = $( 'div[vw-access-button]' );
                $vlibras.trigger( 'click' )
            });

            // Menu complete 
            this.$menuToggle.on( 'click', function(){
                if( Header.$menuToggle.hasClass( 'opened' ) ){
                    Header.$menuToggle.blur();
                    Header.closeFloater();
                }
                else {
                    Header.openFloater();
                }
            });

            // Overlay
            this.$overlay.on( 'mouseover mousemove click touchstart trouchmove', function(){
                Header.unlock();
            });

            // Editorias do menu suspenso
            this.$fltEditorias = $( '.editorias > li', this.$floater );
            this.$fltEditDrops = $( 'ul', this.$fltEditorias );
            this.$fltEditTriggers = this.$fltEditorias.children( 'a' );
            this.$fltEditTriggers.on( 'click', function(e){

                this.$ = this.$ || $( this );
                this.$.drop = this.$.drop || this.$.siblings( 'ul' );

                const viewportWidth = Utils.getPageWidth();

                // Se não tem submenu
                if( !this.$.drop.length || viewportWidth > 640 ){ 
                    return true;
                }
                else {
                    e.preventDefault();
                }

                // Verifica se já está aberto
                var isOpened = this.$.drop.hasClass( 'opened' );

                // Fecha todos os ítems
                Header.$fltEditDrops.removeClass( 'opened' );
                Header.$fltEditTriggers.removeClass( 'opened' );

                // Se não estava aberto, abrimos
                if( !isOpened ){
                    this.$.drop.addClass( 'opened' );
                    this.$.addClass( 'opened' );
                }

            });

            // Window events
            $window
                .resize(function(){
                    if( Header.timeResize ) clearTimeout( Header.timeResize );
                    Header.timeResize = setTimeout( Header.checkSize, 100 );
                })
                .scroll(function(){
                    Header.checkScroll();
                })
            ;

            // Trigger
            Header.checkScroll();
            Header.checkSize();
            Header.bindHeader();

        },

        // Overlay
        overlayOpen : function(){
            Header.$overlay.addClass( 'show' );
        },
        overlayClose : function(){

            Header.$overlay.removeClass( 'show' );

        },

        checkSize : function(){
            const viewportWidth = Utils.getPageWidth();
            if( viewportWidth <= 1270 ){
                Header.$.addClass( 'compact' );
            }  
            else {
                Header.$.removeClass( 'compact' );
            }
        },

        lock : function(){
            Header.locked = true;
            Header.overlayOpen();
            Utils.lockScroll();
        },

        unlock : function(){
            Header.locked = false;
            Header.overlayClose();
            Utils.unlockScroll();
        },

        // Open complete menu
        openFloater : function(){

            Utils.lockScroll();
            
            Header.$menuToggle.addClass( 'opened' );
            Header.$floater
                .addClass( 'opened' )
                .on( 'mouseout', Header.unlock )
                .on( 'mouseover', Header.lock )
            ;
            
            $body.addClass( 'menu-full-opened' );
        
        },

        // Close complete menu
        closeFloater : function(){
        
            Utils.unlockScroll();
            Header.$menuToggle.removeClass( 'opened' );
            
            Header.$floater
                .off( 'mouseout mouseover' )
                .removeClass( 'opened' )
            ;

            $body.removeClass( 'menu-full-opened' );
        
        },

        // Uncheck menu items when is top page
        checkScroll : function(){            
            Header.checkHeader();
        },

        checkHeader : function(){

            var scrollTop = _window.scrollTop();

            // Locked
            if( Header.locked || Header.lastScrolTop === scrollTop ) return true;

            var dir = scrollTop >= Header.lastScrolTop ? 'down' : 'up';
            var sebraeHeight = Header.$sebraeBar.outerHeight();
            var unityHeight = Header.$unityBar.outerHeight();
            var limitInit = Header.$.outerHeight() + sebraeHeight + unityHeight;

            // Initial position
            if( scrollTop > limitInit ){

                if( !Header.$.hasClass( 'floating' ) ){

                     $body
                        .addClass( 'menu-floating' )
                        .addClass( 'menu-unanime' )
                        .removeClass( 'menu-initial' )
                    ;
                    Header.$
                        .addClass( 'floating' )
                        .removeClass( 'initial' )
                    ;
                    Dropdown.closeAll();
                    
                    setTimeout(function(){
                        $body.removeClass( 'menu-unanime' );
                    }, 500 );

                }

            }
            else {

                if( scrollTop <= ( sebraeHeight + unityHeight ) ){

                    var changeMode = false;

                    // Prevent transition
                    if( Header.$.hasClass( 'floating' ) ){
                        changeMode = true;
                        Header.$.addClass( 'prevent-transition' );
                    }
                    
                    $body
                        .removeClass( 'menu-floating' )
                        .addClass( 'menu-initial' )
                    ;
                    Header.$
                        .removeClass( 'floating' )
                        .addClass( 'initial' )
                    ;

                    if( changeMode ){

                        if( Header.timeFixa ) clearTimeout( Header.timeFixa );
                        Header.timeFixa = setTimeout(function(){
                            Header.$.removeClass( 'prevent-transition' );
                        }, 100 );
                    
                    }

                }
            
            }

            // Close menu floater
            if( Header.$floater.hasClass( 'opened' ) ){
                Header.closeFloater();
            }

            // Direction
            $body.removeClass( 'menu-toup menu-todown' );
            Header.$.removeClass( 'toup todown' );
            if( dir === 'up' ){
                $body.addClass( 'menu-toup' );
                Header.$.addClass( 'toup' );
            }
            else {
                $body.addClass( 'menu-todown' );
                Header.$.addClass( 'todown' );
            }

            // Keep last scroll top
            Header.lastScrolTop = scrollTop;
        
        },

        // Binding header
        bindHeader : function(){
            // Initial header check
            Header.checkHeader();
            Header.$.removeClass( 'start' );
        }

    };
    $(function(){ Header.init(); });

})(jQuery);
